"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const app_module_1 = require("./app/app.module");
const environment_ts_1 = require("../../service-lib/src/lib/environment.ts");
const common_bootstrap_1 = require("../../service-lib/src/lib/common-bootstrap"); //import global bootstrap setup from service-lib
async function bootstrap() {
    const commonBootstrap = new common_bootstrap_1.CommonBootstrap();
    const gatewayUrl = environment_ts_1.ENV.URL_API_GATEWAY;
    const port = environment_ts_1.ENV.PORT_API_GATEWAY ? parseInt(environment_ts_1.ENV.PORT_API_GATEWAY, 10) : 3000;
    await commonBootstrap.bootstrap(port, app_module_1.AppModule, 'API Gateway', gatewayUrl, 'api-gateway');
}
bootstrap();
